const screenSizes = {
  mobile: "(max-width:480px)",
  tablet: "(max-width:768px)",
  laptop: "(max-width:1024px)",
  desktop: "(max-width:1200px)",
  large: "(min-width:1400px)",
};

const { mobile, tablet, laptop, desktop, large } = screenSizes;

export { mobile, tablet, laptop, desktop, large };
